import { Injectable } from '@angular/core';
import { Centro } from './centro';
import { Http , Response} from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { Utils } from './../shared/utils';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class CentroService {

  private centroUrl = '/centro';

  constructor(
    private http: Http,
    private _flashMessagesService: FlashMessagesService,
    private utils: Utils
  ) { }

  getCentros(id?:number): Promise<Centro[]> {
    return this.http.get(this.centroUrl, {params: { unidade_id: id}})
                .toPromise()
                .then(response => response.json().dados as Centro[])
                .catch((error) => this.handleError(error));
  }

  getCentrosPorUnidade(id?:number): Promise<Centro[]> {
    let url: string  = this.centroUrl + '/' + id;

    return this.http.get(url)
                .toPromise()
                .then(response => response.json().dados as Centro[])
                .catch((error) => this.handleError(error));
  }

  getCentro(id: number): Promise<Centro>{
    let url: string  = this.centroUrl + '/' + id;
    return this.http.get(url)
               .toPromise()
               .then(response => response.json().dados as Centro)
               .catch((error) => this.handleError(error));
  }

  saveCentro(centro: Centro): Promise<Response>{
    let url: string = this.centroUrl;

    if(centro.id !== undefined)
      url = url + '/' + centro.id;

    return this.http
               .post(url, this.utils.buildFormData(centro))
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  deleteCentro(centro: Centro): Promise<Response>{
    let url: string = this.centroUrl + '/' + centro.id ;
    return this.http
               .delete(url)
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  private handleSuccess(resp: any): Promise<any> {
    this.utils.flashMessage(resp.msg, 'success');
    //this._flashMessagesService.show(resp.msg, { cssClass: 'card alert-success', timeout: 5000 });
    return resp;
  }

  private handleError(error: any): Promise<any> {
     switch (error.status) {
      case 500:
        this.utils.flashMessage('Ocorreu error no servidor, entre em contato com o administrador.', 'danger');
        //this._flashMessagesService.show("Ocorreu error no servidor, entre em contato com o administrador.", { cssClass: 'card alert-danger', timeout: 5000 });
        break;
      case 403:
        this.utils.flashMessage(error.json().msg, 'warning');
        //this._flashMessagesService.show(error.json().msg, { cssClass: 'card alert-warning', timeout: 5000 });
        break;
      default:
      this.utils.flashMessage("Ocorreu um error, tente novamente mais tarde.", 'danger');
        //this._flashMessagesService.show("Ocorreu um error, tente novamente mais tarde.", { cssClass: 'card alert-danger', timeout: 5000 });
    }
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/centros/centro.service.ts